import { ComponentMultiStyleConfig } from "@chakra-ui/react";

const parts = ["container", "header", "body"];

const card: ComponentMultiStyleConfig = {
  parts,
  baseStyle: {
    container: {
      bg: "#ffffff",
      borderRadius: "md",
      boxShadow: "base"
    },
    header: {
      padding: 4,
      borderBottomWidth: 1
    },
    footer: {
      padding: 4,
      borderTopWidth: 1
    },
    body: {
      padding: 4
    }
  }
};

export default card;
